(() => {
  const root = document.querySelector('.ms2[data-mello-page]');
  if (!root) return;
  const form = root.querySelector('[data-product-form]');
  const mobilePrice = root.querySelector('[data-mobile-price]');
  const mobileBar = root.querySelector('[data-mobile-bar]');
  root.querySelectorAll('.ms2-bundle input').forEach((input) => input.addEventListener('change', () => {
    root.querySelectorAll('.ms2-bundle').forEach((card) => card.classList.toggle('is-selected', card.contains(input)));
    const card = input.closest('.ms2-bundle');
    const price = card.querySelector('.ms2-bundle__head strong')?.textContent.trim();
    const addLabel = form?.querySelector('[data-add-label]');
    if (price && addLabel) addLabel.textContent = `ADD TO CART — ${price}`;
    if (price && mobilePrice) mobilePrice.textContent = price;
  }));
  if (form && mobileBar && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => mobileBar.classList.toggle('is-hidden', entry.isIntersecting), { threshold: .15 }).observe(form);
  }
})();
